// import React from "react";
// import { Container, Row } from "react-bootstrap";
// import axios from "axios";

// function ThreadHistory({ history }) {
//   function fetchData(id) {
//     axios
//       .get(`/getChat?id=${id}`)
//       .then((response) => {
//         // Handle response data
//         console.log(response.data);
//       })
//       .catch((error) => {
//         // Handle errors
//         console.error("Error fetching chat:", error);
//       });
//   }

//   function handleClick(id) {
//     fetchData(id);
//   }

//   return (
//     <Container
//       fluid
//       style={{
//         height: "82vh",
//         overflow: "auto",
//       }}
//       className="py-2"
//     >
//       {history.map((item, index) => (
//         <Row
//           key={index}
//           className="py-1 ps-3"
//           onClick={() => handleClick(item.id)}
//           style={{ cursor: "pointer" }}
//         >
//           {item.title}
//         </Row>
//       ))}
//     </Container>
//   );
// }

// export default ThreadHistory;


import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Container, Row, Col, Button } from "react-bootstrap";
import axios from "axios";
import moment from "moment"; // You may need to install moment for date manipulation
import { useWorkspace } from "../../../contexts/WorkspaceContext";
import sourceUrl from "../../../api/Source.api";
import { useMediaQuery } from "react-responsive";
import ShareModal from "../message/ShareModal";
import { ChatBubbleOutlineOutlined as ChatBubbleOutlineOutlinedIcon } from '@mui/icons-material';
import { hovered_chat_bg_color, selected_chat_bg_color } from "../../../constants/colors";
import { trackProjectInteraction } from "../../../config/analytics";
import DeleteAndShareModal from "../message/DeleteAndShareModal";

const CustomContainer = styled(Container)`
  overflow: auto;
  padding-right: 30px;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => (theme === 'dark' ? '#2c2c2c' : '#f1f1f1')};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => (theme === 'dark' ? '#888' : '#ccc')};
    border-radius: 10px;
    border: 2px solid ${({ theme }) => (theme === 'dark' ? '#2c2c2c' : '#f1f1f1')};
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

function ThreadHistory() {
  const {setShowLeftsideBar,setThreadFiles,setCurrentHistoryId,currentThread,setCurrentThread,threadId,setThreadId,setHistoryFiles,Today,Yesterday,ThisWeek,ThisMonth,PrevMonth,threadFiles,InvokeMatrixApi,currentHistoryId} = useWorkspace()
  
  const token = localStorage.getItem('token');
  const [history,setHistory] = useState([]);
  const [today,set_today] = useState(Today || []);
  const [yesterday,set_yesterday] = useState(Yesterday || []);
  const [thisWeek,set_thisWeek] = useState(ThisWeek || []);
  const [thisMonth,set_thisMonth] = useState(ThisMonth || []);
  const [prevMonth,setPrevMonth] = useState(PrevMonth || []) ;
  const isXsOrSm = useMediaQuery({ maxWidth: 1280 });
  const theme = localStorage.getItem('theme');
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    set_today(Today);
    set_yesterday(Yesterday);
    set_thisWeek(ThisWeek);
    set_thisMonth(ThisMonth);
    setPrevMonth(PrevMonth);
  }, [Today, Yesterday, ThisWeek, ThisMonth, PrevMonth]);

  const handleClick = async (item) => {
    trackProjectInteraction(item.title, "Open");
    if(isXsOrSm){
      setShowLeftsideBar(false);
    }
    const {id,thread_id} = item ;
    setThreadFiles([]);
    setCurrentHistoryId(id);
    try {
      const res = await axios.get(`${sourceUrl}/chat/${id}/history`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      // console.log("current_history_threadData",res);

      // ==================
      setThreadId(`thread-${thread_id}`)
      // ==================
      setCurrentThread(res.data.data.history);
      
      if(res.data.data && res.data.data.input_files&& res.data.data.input_files.length){
        setHistoryFiles(res.data.data.input_files)
      }
      else{
        setHistoryFiles([])
      }
      // ==========================Invoke matrix api ===================================================
        // Invoke matrix API
        try {
          const data = {
            url: 'history',
            threadId: threadId,
            requestId: res.data.requestID,
            requestType: 'GET',
            requestBody: {},
            responseBody: {},
            responseCode: res.status
          };
        
          const headers = {
            'Content-Type': 'application/json'
          };
        
          const matrix_Res = await axios.post(`${sourceUrl}/add`, data, { headers });

        } catch (error) {
          console.error('Error making the POST request:', error);
        }
        // await InvokeMatrixApi(res, res, 'GET',threadId, 'history', {});
      // ===============================================================================================
      
      // console.log("here is the updated curr_thread",currentThread);
    } catch (error) {
      console.log(error);
      // ==========================Invoke matrix api ===================================================
        // Invoke matrix API
        await InvokeMatrixApi(error, error.data, 'GET',threadId, 'summary', {});
      // ===============================================================================================
    }
  }

  const handleMouseEnter = (itemId) => {
    setHoveredItemId(itemId);
  };

  const handleMouseLeave = () => {
    setHoveredItemId(null);
  };

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const [clickedIndex, setClickedIndex] = useState(null); // State to track which index was clicked
  const [clickThisWeek, setClickThisWeek] = useState(null)
  const [clickyesterday, setYesterday] = useState(null)
  const [clickThisMonth, setThisMonth] = useState(null)
  const [clickPreMonth, setPreMonth] = useState(null)

  const deleteAndShareFun = (index) => {
    setClickedIndex(index); // Set the clicked index
    // Add any additional logic here, if needed
    setShowModal(!showModal)
    setClickThisWeek(null)
    setYesterday(null)
    setThisMonth(null)
    setPreMonth(null)
  };
 
  const clickYesterdayFun = (index) =>{
    setYesterday(index)
    setShowModal(!showModal)
    setClickedIndex(null)
    setClickThisWeek(null)
    setThisMonth(null)
    setPreMonth(null)

    
  }

const clickThisWeekFunc = (index) =>{
  setClickThisWeek(index)
  setShowModal(!showModal)
  setClickedIndex(null)
  setYesterday(null)
  setThisMonth(null)
  setPreMonth(null)
}

const clickThisMonthFun = (index) =>{
  setThisMonth(index)
  setShowModal(!showModal)
  setClickedIndex(null)
  setYesterday(null)
  setClickThisWeek(null)
  setPreMonth(null)
  
}
const clickPreMonthFun = (index) =>{
  setPreMonth(index)
  setShowModal(!showModal)
  setClickedIndex(null)
  setYesterday(null)
  setClickThisWeek(null)
  setThisMonth(null)

}
  // const deleteAndShareFun = () =>{
  //   setShowModal(!showModal)
  // }
  
  
  return (
    <CustomContainer 
    style={{ minHeight : '100%'}}
      fluid
      theme={theme}
      className="py-2"
    >
      <div  style={{fontSize:'.9rem'}}>
                  {/* {today.length?
                    <Row  className="py-1 ps-1">
                      <strong className="p-0 m-0 text-secondary" >Today</strong>
                    </Row> :
                    '' 
                  }
                  {today.map((item, index) => (
                    <Row key={index} className="py-1 ps-3" style={{display:'flex',justifyItems:'space-between',alignSelf:'center'}}>
                      <Col
                        key={index}
                        // className="p-0 m-0"
                        onClick={() => handleClick(item)}
                        style={{
                          cursor: "pointer",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          backgroundColor:currentHistoryId == item.id? theme === 'dark'?'#212529':'white':'',
                          padding: currentHistoryId == item.id ? '10px' : '0',
                          borderRadius:currentHistoryId == item.id?'10px':'',
                          display:'flex', 
                        }}
                      >
                        <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                          {item.title}
                        </div>
                        {currentHistoryId === item.id && <button style={{ backgroundColor: 'transparent', border: 'none' }}><i className="bi bi-three-dots-vertical"></i></button>}
                      </Col>
                    </Row>
                  ))} */}
                  {today.length ? (
                    <Row  className="py-1 ps-1">
                      
                      {/* <p style={{color:theme === 'dark'?'#FFFFFF':'',fontSize:'16px',fontWeight:'500',paddingLeft:'0',backgroundColor:'red'}}>Today</p> */}
                      <p className="p-0 m-0" style={{color:theme === 'dark'?'#FFFFFF':'',fontSize:'16px',fontWeight:'500'}}>Today</p>
                    </Row>
                    
                    
                  ) : (
                    ""
                  )}
               
                  
                  {today.map((item, index) => (
                    <Row
                      key={index}
                      className="py-1 ps-3"
                      style={{
                        display: "flex",
                        justifyItems: "space-between",
                        alignSelf: "center",
                        // position : 'relative',

                      }}
                    >
                      {/* {index == 1 ?  <DeleteAndShareModal  showModal={showModal} /> : "" } */}
                      
                        
                      
                      <Col
                        key={index}
                        onClick={() => handleClick(item)}
                        onMouseEnter={() => handleMouseEnter(item.id)}
                        onMouseLeave={handleMouseLeave}
                        style={{
                          cursor: "pointer",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          backgroundColor:
                            currentHistoryId === item.id
                              ? theme === "dark"
                                ? selected_chat_bg_color
                                : "white"
                              : hoveredItemId === item.id
                              ? theme === "dark"
                                ? hovered_chat_bg_color
                                : "white"
                              : "",
                          // padding:
                          //   currentHistoryId === item.id || hoveredItemId === item.id
                          //     ? "10px"
                          //     : "0",
                          borderRadius:
                            currentHistoryId === item.id || hoveredItemId === item.id
                              ? "10px"
                              : "",
                          display: "flex",
                          padding:'10px 12px 10px 6px'
                        }}
                      > 
                        <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",fontSize:'14px' }}>
                          <ChatBubbleOutlineOutlinedIcon sx={{ marginRight: 1 }} />
                          
                          {item.title}
                        </div>
                        {(currentHistoryId === item.id || hoveredItemId === item.id) && (
                          <button style={{ backgroundColor: "transparent", border: "none"}} 
                          // onClick={deleteAndShareFun}
                          onClick={() => deleteAndShareFun(index)} 
                          >
                            <i className="bi bi-three-dots-vertical"></i>
                          </button>
                        )}
                      </Col>
                      
                      
                      {/* <div style={{ position : "absolute", marginTop : '100px'}}> */}
                      {clickedIndex === index && <DeleteAndShareModal showModal={showModal} />}
                      {/* </div> */}
                    </Row>
                  ))}
                  {yesterday.length?
                    <Row  className="py-1 ps-1">
                      <p className="p-0 m-0" style={{color:theme === 'dark'?'#FFFFFF':'',fontSize:'16px',fontWeight:'500'}}>Yesterday</p>
                    </Row> :
                    '' 
                  }
                  
                  {yesterday.map((item, index) => (
                    <Row
                      key={index}
                      className="py-1 ps-3"
                      style={{
                        display: "flex",
                        justifyItems: "space-between",
                        alignSelf: "center"
                      }}
                    >
                      {/* <DeleteAndShareModal show={showModal} handleClose={handleCloseModal} showModal={showModal} /> */}
                    
                      <Col
                        key={index}
                        onClick={() => handleClick(item)}
                        onMouseEnter={() => handleMouseEnter(item.id)}
                        onMouseLeave={handleMouseLeave}
                        style={{
                          cursor: "pointer",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          backgroundColor:
                            currentHistoryId === item.id
                              ? theme === "dark"
                                ? selected_chat_bg_color
                                : "white"
                              : hoveredItemId === item.id
                              ? theme === "dark"
                                ? hovered_chat_bg_color
                                : "white"
                              : "",
                          // padding:
                          //   currentHistoryId === item.id || hoveredItemId === item.id
                          //     ? "10px"
                          //     : "0",
                          borderRadius:
                            currentHistoryId === item.id || hoveredItemId === item.id
                              ? "10px"
                              : "",
                          display: "flex",
                          padding:'10px 12px 10px 6px'
                        }}
                      >
                        <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",fontSize:'14px' }}>
                          <ChatBubbleOutlineOutlinedIcon sx={{ marginRight: 1 }} />
                          {item.title}
                        </div>
                        {(currentHistoryId === item.id || hoveredItemId === item.id) && (
                          <button style={{ backgroundColor: "transparent", border: "none" }} 
                          // onClick={deleteAndShareFun}
                          onClick={() => clickYesterdayFun(index)} 
                          >
                            <i className="bi bi-three-dots-vertical"></i>
                          </button>
                        )}
                      </Col>
                      {clickyesterday === index && <DeleteAndShareModal showModal={showModal} />}
                    </Row>
                  ))}
                  {thisWeek.length?
                    <Row  className="py-1 ps-1">
                      <p className="p-0 m-0" style={{color:theme === 'dark'?'#FFFFFF':'',fontSize:'16px',fontWeight:'500'}}>This Week</p>
                    </Row> :
                    '' 
                  }
                  
                  {thisWeek.map((item, index) => (
                    <Row
                      key={index}
                      className="py-1 ps-3"
                      style={{
                        display: "flex",
                        justifyItems: "space-between",
                        alignSelf: "center"
                      }}
                    >
                      {/* <DeleteAndShareModal show={showModal} handleClose={handleCloseModal} showModal={showModal} /> */}
                      
                      <Col
                        key={index}
                        onClick={() => handleClick(item)}
                        onMouseEnter={() => handleMouseEnter(item.id)}
                        onMouseLeave={handleMouseLeave}
                        style={{
                          cursor: "pointer",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          backgroundColor:
                            currentHistoryId === item.id
                              ? theme === "dark"
                                ? selected_chat_bg_color
                                : "white"
                              : hoveredItemId === item.id
                              ? theme === "dark"
                                ? hovered_chat_bg_color
                                : "white"
                              : "",
                          // padding:
                          //   currentHistoryId === item.id || hoveredItemId === item.id
                          //     ? "10px"
                          //     : "0",
                          borderRadius:
                            currentHistoryId === item.id || hoveredItemId === item.id
                              ? "10px"
                              : "",
                          display: "flex",
                          padding:'10px 12px 10px 6px'
                        }}
                      >
                        <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",fontSize:'14px' }}>
                          <ChatBubbleOutlineOutlinedIcon sx={{ marginRight: 1 }} />
                          {item.title}
                        </div>
                        {(currentHistoryId === item.id || hoveredItemId === item.id) && (
                          <button style={{ backgroundColor: "transparent", border: "none" }} 
                          // onClick={deleteAndShareFun}
                          onClick={() => clickThisWeekFunc(index)} 
                          >
                            <i className="bi bi-three-dots-vertical"></i>
                          </button>
                        )}
                      </Col>
                      {clickThisWeek === index && <DeleteAndShareModal showModal={showModal} />}
                    </Row>
                  ))}
                  {thisMonth.length?
                    <Row  className="py-1 ps-1">
                      <p className="p-0 m-0" style={{color:theme === 'dark'?'#FFFFFF':'',fontSize:'16px',fontWeight:'500'}}>This Month</p>
                    </Row> :
                    '' 
                  }
                  
                  {thisMonth.map((item, index) => (
                    <Row
                      key={index}
                      className="py-1 ps-3"
                      style={{
                        display: "flex",
                        justifyItems: "space-between",
                        alignSelf: "center"
                      }}
                    >
                       
                      <Col
                        key={index}
                        onClick={() => handleClick(item)}
                        onMouseEnter={() => handleMouseEnter(item.id)}
                        onMouseLeave={handleMouseLeave}
                        style={{
                          cursor: "pointer",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          backgroundColor:
                            currentHistoryId === item.id
                              ? theme === "dark"
                                ? selected_chat_bg_color
                                : "white"
                              : hoveredItemId === item.id
                              ? theme === "dark"
                                ? hovered_chat_bg_color
                                : "white"
                              : "",
                          // padding:
                          //   currentHistoryId === item.id || hoveredItemId === item.id
                          //     ? "10px"
                          //     : "0",
                          borderRadius:
                            currentHistoryId === item.id || hoveredItemId === item.id
                              ? "10px"
                              : "",
                          display: "flex",
                          padding:'10px 12px 10px 6px'
                        }}
                      >
                        <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",fontSize:'14px'}}>
                          <ChatBubbleOutlineOutlinedIcon sx={{ marginRight: 1 }} />
                          {item.title}
                        </div>
                        {(currentHistoryId === item.id || hoveredItemId === item.id) && (
                          <button style={{ backgroundColor: "transparent", border: "none" }} 
                          // onClick={deleteAndShareFun}
                          onClick={() => clickThisMonthFun(index)} 
                          >
                            <i className="bi bi-three-dots-vertical"></i>
                          </button>
                        )}
                      </Col>
                      {clickThisMonth === index && <DeleteAndShareModal showModal={showModal} />}
                    </Row>
                  ))}
                  {prevMonth.length?
                    <Row  className="py-1 ps-1">
                      <p className="p-0 m-0" style={{color:theme === 'dark'?'#FFFFFF':'',fontSize:'16px',fontWeight:'500'}}>Previous Month</p>
                    </Row> :
                    '' 
                  }
                  
                  {prevMonth.map((item, index) => (
                    <Row
                      key={index}
                      className="py-1 ps-3"
                      style={{
                        display: "flex",
                        justifyItems: "space-between",
                        alignSelf: "center"
                      }}
                    >
                      
                      <Col
                        key={index}
                        onClick={() => handleClick(item)}
                        onMouseEnter={() => handleMouseEnter(item.id)}
                        onMouseLeave={handleMouseLeave}
                        style={{
                          cursor: "pointer",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          backgroundColor:
                            currentHistoryId === item.id
                              ? theme === "dark"
                                ? selected_chat_bg_color
                                : "white"
                              : hoveredItemId === item.id
                              ? theme === "dark"
                                ? hovered_chat_bg_color
                                : "white"
                              : "",
                          // padding:
                          //   currentHistoryId === item.id || hoveredItemId === item.id
                          //     ? "10px"
                          //     : "0",
                          borderRadius:
                            currentHistoryId === item.id || hoveredItemId === item.id
                              ? "10px"
                              : "",
                          display: "flex",
                          padding:'10px 12px 10px 6px'
                        }}
                      >
                        <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                          <ChatBubbleOutlineOutlinedIcon sx={{ marginRight: 1 }} />
                          {item.title}
                        </div>
                        {(currentHistoryId === item.id || hoveredItemId === item.id) && (
                          <button style={{ backgroundColor: "transparent", border: "none" }}
                          //  onClick={deleteAndShareFun}
                          onClick={() => clickPreMonthFun(index)} 
                           >
                            <i className="bi bi-three-dots-vertical"></i>
                          </button>
                        )}
                      </Col>
                      {clickPreMonth === index && <DeleteAndShareModal showModal={showModal} />}
                    </Row>
                  ))}
              </div>
              {/* <ShareModal show={showModal} handleClose={handleCloseModal} /> */}
                 {/* <DeleteAndShareModal show={showModal} handleClose={handleCloseModal} showModal={showModal} /> */}
              

    </CustomContainer>
  )
}

export default ThreadHistory;


